<h2 mat-dialog-title>Edit Patreon Account</h2>
<mat-dialog-content>
    @if (data && data.connections.patreon) {
        <div style="display: flex; gap: 10px; flex-direction: column;">
            <mat-form-field>
                <mat-label>Patreon ID</mat-label>
                <input matInput [(ngModel)]="data.connections.patreon.id" />
            </mat-form-field>

            <mat-form-field>
                <mat-label>Patreon Username</mat-label>
                <input matInput [(ngModel)]="data.connections.patreon.username" />
            </mat-form-field>

            <mat-form-field>
                <mat-label>Patreon Email</mat-label>
                <input matInput [(ngModel)]="data.connections.patreon.email" />
            </mat-form-field>

            @if (data.type === 'guest') {
                <mat-form-field>
                    <mat-label>Expire Date</mat-label>
                    <input matInput type="datetime-local" [(ngModel)]="data.connections.patreon.expire" />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Connected Date</mat-label>
                    <input matInput type="datetime-local" [(ngModel)]="data.connections.patreon.connected_at" />
                </mat-form-field>
            }

            @if (data.type === 'user') {
                <div>
                    <mat-checkbox 
                        [(ngModel)]="data.connections.patreon.overridden"
                    >
                        Override Tier
                    </mat-checkbox><br>
                    <small style="color: var(--mat-sys-on-surface-variant)">Overriding a tier means it wont be updated automatically, so dont use this unless you have to</small>
                </div>
            }

            <mat-form-field>
                <mat-label>Patreon Tier</mat-label>
                <mat-select [disabled]="data.type === 'user' && !data.connections.patreon.overridden" [(ngModel)]="selectedTierId" (ngModelChange)="onTierChange($event)">
                    @for (tier of tiers | keyvalue ; track tier.key) {
                        <mat-option [value]="tier.key">
                            {{ tier.value.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    } @else {
        Something went wrong
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
    <button mat-button (click)="save()">Save</button>
</mat-dialog-actions>